import { 
    CREATEBLOODBANKPRODUCT,
    CREATEBLOODBANKTYPE,
    DELETEBLOODBANKPRODUCT,
    DELETEBLOODBANKTYPE,
    GETBLOODBANKPRODUCT,
    GETBLOODBANKTYPE,
    UPDATEBLOODBANKPRODUCT,
    UPDATEBLOODBANKTYPE,
     } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEBLOODBANKPRODUCT:
            return {
                ...state,
                bloodbankproductSaveStatus: action.payload.success,
            }
        case GETBLOODBANKPRODUCT:
                return {
                        ...state,
                        bloodbankproductList: action.payload.data,
                        }
        case UPDATEBLOODBANKPRODUCT:
                return {
                        ...state,
                        bloodbankproductUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKPRODUCT:
                 return {
                     ...state,
                     bloodbankproductDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKTYPE:
            return {
                ...state,
                bloodbanktypeSaveStatus: action.payload.success,
            }
        case GETBLOODBANKTYPE:
                return {
                        ...state,
                        bloodbanktypeList: action.payload.data,
                        }
        case UPDATEBLOODBANKTYPE:
                return {
                        ...state,
                        bloodbanktypeUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKTYPE:
                 return {
                     ...state,
                     bloodbanktypeDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                                  }
                             }